import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import { sortSizeData } from "../helpers"

import Facet from "./elements/Facet"
import ColorFacet from "./elements/ColorFacet"
import RangeFacet from "./elements/RangeFacet"

export default function Sidebar({ facetsOpen, toggleFacets }) {
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();

    return facets?.length > 0 ? (
        <>
            <aside
                id="ns-sidebar"
                aria-expanded={facetsOpen}
                aria-label="Filter options"
            >
                {/* HEADER */}
                <div class="ns-sidebar__header">
                    <div class="ns-sidebar__header-heading">Filters</div>
                    <button
                        class="ns-sidebar__header-close-btn"
                        type="button"
                        aria-label="Close filters sidebar"
                        onClick={toggleFacets}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17" width="18">
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
                
                {/* CONTENT */}
                <div class="ns-sidebar__body">
                    <div>
                        {facets?.map(facet => {
                            if(facet.type === 'terms') {
                                if(facet.name === 'Size') {
                                    sortSizeData(facet.data)
                                }
                                return (facet.name === 'Color') 
                                    ? (<ColorFacet facet={facet} key={facet.id} />)
                                    : (<Facet facet={facet} key={facet.id} />)
                            } else if (facet.type === 'stats') {
                                return (<RangeFacet facet={facet} key={facet.id} />)
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>

                {/* FOOTER */}
                <div class="ns-sidebar__footer">
                    <button 
                        type="button"
                        aria-label="Apply current filters"
                        onClick={toggleFacets}
                    >
                        Apply
                    </button>

                    <button
                        type="button"
                        disabled={filters.length < 1}
                        aria-label="Remove all filters"
                        onClick={removeAll}
                    >
                        Clear All
                    </button>
                </div>
            </aside>

            {/* backdrop */}
            <div
                class="ns-sidebar__backdrop"
                aria-label="Close filters sidebar"
                role="button"
                tabIndex="0"
                onClick={toggleFacets}
            ></div>
        </>
    ) : ( null )
}
